module.exports = __webpack_public_path__ + "static/media/2025_Gorrissen_Federspie.50c47ab7.png";